import { Loader } from '@mantine/core'
import { Navigate, Outlet } from 'react-router-dom'

import { EmmaPath } from '@/router/paths'

import { useAuth } from './use-auth'

interface AuthorizedRouteProps {
  authorizedRoles: string[]
}

export const AuthorizedOutlet = ({ authorizedRoles = [] }: AuthorizedRouteProps) => {
  const { isAuthenticated, matchRoles, isLoading } = useAuth()

  if (isLoading) {
    return <Loader />
  }

  if (!isAuthenticated) {
    return <Navigate to={EmmaPath.SIGN_IN} />
  }

  if (matchRoles(authorizedRoles as any)) {
    return <Outlet />
  }

  return <Navigate to={EmmaPath.EMMA} />
}
